module.exports = __webpack_public_path__ + "static/media/reciclables-06.1ff50ef3.png";